// Application configuration
export const INVITE_SYSTEM_ENABLED = false; // Set to false to disable invite system
export const SHOW_CRUISE_AD = false; // Set to additfalse to hide cruise advertisements
export const SHOW_DATA_MANAGEMENT = false; // Enable data management section
export const REWIND_DEBUG_MODE = false; // Set to true to show Rewind banner outside of December
export const SHOW_FRIENDS_BUTTON = true; // Set to true to show friends button in navigation bar
export const SHOW_NOTIFICATION_BUTTON = true; // Set to true to show notification button in navigation bar
export const DEBUG_MODE = false; // Set to true to enable debug logging (console.log, console.debug, etc.)

// Other app configuration can go here
export const APP_VERSION = '3.4.0';
export const ITINERARY_FILTER_DAYS = 15; // Number of days in the past to include itineraries (itineraries older than this will be filtered out)
